import * as React from 'react';
import { connect } from 'react-redux';
import { getDamageCausesByProductIncidentTypeId, handleNextStep, handleStepBack, setReducer } from '../../../actions/claimSubmitActions';
import {
    SET_CLAIM_DATA,
    THEFT_MOTORBIKE_COVER_TYPE, THEFT_WRITEOFF_CAR_COVER_TYPE,
    THIRDPARTY_CAR_COVER_TYPE, THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE, THIRDPARTY_MOTORBIKE_COVER_TYPE, THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE,
    COMPREHENSIVE_MOTORBIKE_COVER_TYPE } from '../../../constants/constants';
import { ClaimGuiltyParties } from '../../../constants/Enums';
import { IDropdownData } from '../../../interfaces/KPDropdown/KPDropdownInterfaces';
import KPDropdown from '../../BaseTemplate/SSPCustomComponentLibrary/KPDropdown/KPDropdown';

class IncidentInfo extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            nextDisabled: true,
            ClaimGuiltyParties: [
                {
                    "id": ClaimGuiltyParties.DriverOfInsuredVehicle,
                    "description": "Driver of the insured car/motorbike"
                },
                {
                    "id": ClaimGuiltyParties.OtherParty,
                    "description": "Driver of the third party car/motorbike"
                }
            ],
        }

        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleSelection = this.handleSelection.bind(this);
        this.handleCheckValidation = this.handleCheckValidation.bind(this);
    }

    async componentDidMount() {
        this.props.dispatchAction(getDamageCausesByProductIncidentTypeId());
        this.handleCheckValidation();
    }

    handleCheckValidation() {
        var guiltyParty = this.props.claimSubmit.claimGuiltyParty
        var damageCause = this.props.claimSubmit.damageCauseId
        if (damageCause !== "" && guiltyParty !== "") {
            this.setState({ nextDisabled: false });
        }
        else {
            this.setState({ nextDisabled: true });
        }
    }

    async handleNext() {
        await this.handleCheckValidation();
        if (!this.state.nextDisabled) {
            await this.props.dispatchAction(handleNextStep())
        }
    }

    handleBack() {
        this.props.dispatchAction(handleStepBack())
    }

    async handleSelection(e: any, selectionType: any) {
        this.props.dispatchAction(setReducer(SET_CLAIM_DATA, selectionType, Number(e)));
        this.handleCheckValidation();
    }

    public render() {
        let damageCauses = this.props.claimSubmit.damageCauses;
        let damageCausesDropdown = [] as Array<IDropdownData>;
        let guiltyParties = this.state.ClaimGuiltyParties;
        let guiltyPartiesDropdown = [] as Array<IDropdownData>;

        if (damageCauses.length > 0) {
            damageCausesDropdown = this.props.claimSubmit.damageCauses.map((item) => {
                let tempDropdown: IDropdownData = {
                    description: item.description,
                    id: String(item.id),
                    image: "",
                    productName: ""
                };
                return tempDropdown;
            });
        }

        if (guiltyParties.length > 0) {
            guiltyPartiesDropdown = this.state.ClaimGuiltyParties.map((item) => {
                let tempDropdown: IDropdownData = {
                    description: item.description,
                    id: String(item.id),
                    image: "",
                    productName: ""
                };
                return tempDropdown;
            });
        }

        let hasNotice: boolean = true;
        let pleaseNote = <></>;
        switch (this.props.claimSubmit.selectedRiskItem.productId.toUpperCase()) {
            // Theft
            case THEFT_MOTORBIKE_COVER_TYPE: {
                hasNotice = false;
                break;
            }
            case THEFT_WRITEOFF_CAR_COVER_TYPE: {
                pleaseNote = <><p className="font-weight-normal line-height-1-41 noma nopa">Don’t worry! Even if the insured person driving the car is the guilty party, you’re still covered. The info you give us below, will just give us a heads up to expect a claim from another party. If your car is written off and your claim is approved, it'll help us to try and recover your excess, if a third party is liable.</p></>
                break;
            }
            // Thirdparty - Motorbike 
            case THIRDPARTY_MOTORBIKE_COVER_TYPE:
            case THIRDPARTY_THEFT_MOTORBIKE_COVER_TYPE: {
                pleaseNote = <><p className="font-weight-normal line-height-1-41 noma nopa">Don’t worry! Even if the insured person riding the motorbike is the guilty party, you’re still covered. The info you give us below, will just give us a heads up to expect a claim from another party.</p></>
                break;
            }
            // Thirdparty - Car 
            case THIRDPARTY_CAR_COVER_TYPE:
            case THIRDPARTY_FIRETHEFT_CAR_COVER_TYPE: {
                pleaseNote = <><p className="font-weight-normal line-height-1-41 noma nopa">Don’t worry! Even if the insured person driving the car is the guilty party, you’re still covered. The info you give us below, will just give us a heads up to expect a claim from another party.</p></>
                break;
            }
            // Comprehensive - Motorbike
            case COMPREHENSIVE_MOTORBIKE_COVER_TYPE: {
                pleaseNote = <><p className="font-weight-normal line-height-1-41 noma nopa">Don’t worry! Even if the insured person riding the motorbike is the guilty party, you’re still covered. The info you give us below, will just give us a heads up to expect a claim from another party. It’ll also enable us to do a recovery of the costs if your claim is approved and the other party is the guilty party.</p></>
                break;
            }
            // Comprehensive - Car (Default)
            default: {
                pleaseNote = <><p className="font-weight-normal line-height-1-41 noma nopa">Don’t worry! Even if the insured person driving the car is the guilty party, you’re still covered. The info you give us below, will just give us a heads up to expect a claim from another party. It’ll also enable us to do a recovery of the costs if your claim is approved and the other party is the guilty party.</p></>
            }
        }

        return <>
            <div className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding incident-info">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-claim-info">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red.png'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>{this.props.claimSubmit.selectedClaimStep.title}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma">
                    <div className="col-12 nopa">
                        <hr className="hr-minus21px" />
                        <p className="font-weight-normal line-height-normal mb-20px">We need a few more details to process your claim.</p>
                        <p className="font-weight-bold line-height-normal mb-20px">Judging from the description of the incident, please select in your opinion the guilty party:</p>
                        {hasNotice &&
                            <div className="extra-info">
                                {pleaseNote}
                            </div>
                        }
                    </div>
                    <div className="col-12 nopa mt-20px">
                        <div className="incident-info-form">
                            <div className="form-group">
                                <KPDropdown id={"claim-select-gulity-dropdown"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={true}
                                    showLabelOutside={false}
                                    isRiskItem={false}
                                    labelAfterSelection={"Select guilty party"}
                                    title={"Select guilty party"}
                                    label={"Select guilty party"}
                                    data={guiltyPartiesDropdown}
                                    handleSelection={(e) => this.handleSelection(e, 'claimGuiltyParty')}
                                    selectedValue={guiltyPartiesDropdown.find(x => x.id == String(this.props.claimSubmit.claimGuiltyParty))} />
                            </div>
                        </div>
                    </div>
                    <div className="col-12 nopa mt-20px">
                        <div className="incident-info-form">
                            <div className="form-group pb-30px">
                                <KPDropdown id={"claim-damage-causes-dropdown"}
                                    isImageDropdown={false}
                                    showLabelAfterSelection={true}
                                    showLabelInside={true}
                                    showLabelOutside={false}
                                    isRiskItem={false}
                                    labelAfterSelection={"How did the incident occur"}
                                    title={"How did the incident occur"}
                                    label={"How did the incident occur"}
                                    data={damageCausesDropdown}
                                    handleSelection={(e) => this.handleSelection(e, 'damageCauseId')}
                                    selectedValue={damageCausesDropdown.find(x => x.id == String(this.props.claimSubmit.damageCauseId))} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row noma incident-info-footer">
                    <div className="col-12 nopa">
                        <hr className="hr-minus21px" />
                    </div>
                </div>
            </div>
            <div className="col-12 nopa fnol-where-it-happened-buttonholder pb-20px">
                <button className="btn btn-solid-red fnol-buttonreverse-button-next" id="btnIncideInfoNext" onClick={this.handleNext} disabled={this.state.nextDisabled}>Next</button>
                <button className="btn btn-outline-red fnol-buttonreverse-button-back" id="btnIncideInfoBack" disabled={true} onClick={this.handleBack}>Back</button>
            </div>
        </>
    }
}

const mapStateToProps = (state: any) => {
    return {
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IncidentInfo)